import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const useAuthStore = new Vuex.Store({
  state: {
    userinfo: {},
    isAuthenticated: false,
    balance: {
      total: { emails: 0, checkins: 0 },
      used: { emails: 0, checkins: 0 },
      remaining: { emails: 0, checkins: 0 }
    }

  },
  mutations: {
    setUserinfo (state, userinfo) {
      state.userinfo = userinfo
      state.isAuthenticated = true
    },

    setCompany (state, compnay) {
      state.userinfo.company_id = compnay
    },

    aliveLogin (state) {
      state.isAuthenticated = true
    },

    logout (state) {
      state.userinfo = {}
      state.isAuthenticated = false
    },
    setNewBalance (state, json) {
      state.userinfo.balance = json
    }

  },
  actions: {
    authenticate ({ commit }, json) {
      commit('setUserinfo', json)
    },
    modidyCompany ({ commit }, json) {
      commit('setCompany', json)
    },
    aliveAuth ({ commit }) {
      commit('aliveLogin')
    },
    logout ({ commit }) {
      commit('logout')
    },
    newBalance ({ commit }, json) {
      commit('setNewBalance', json)
    }

  },
  getters: {
    userInfo: (state) => state.userinfo,
    uid: (state) => state.userinfo.uid,
    isAuthenticated: (state) => state.isAuthenticated,
    timezone: (state) => state.userinfo.company_id.country.timezone,
    balance: (state) => state.userinfo.balance
  },
  plugins: [
    createPersistedState({
      key: 'authStore',
      // Scegli dove persistere lo stato
      storage: window.localStorage, // O window.sessionStorage, o Cookies
      // Quali moduli o parti dello stato vuoi persistere
      paths: [
        'isAuthenticated', // Persisti solo lo stato di autenticazione
        'userinfo' // Persisti le informazioni dell'utente

      ]

    })
  ]
})

export default useAuthStore
